/* ÀMBA — mobile search; homepage gets a dedicated natural-flow treatment. */
(() => {
  const mobileQuery = window.matchMedia('(max-width: 767px)');
  const bar = document.getElementById('Amba-Mobile-Search');
  const header = document.querySelector('theme-header.header');
  if (!bar || !header) return;

  const headerSection = bar.closest('.header-section');
  const toggles = Array.from(document.querySelectorAll('.amba-mobile-search-toggle'));
  const input = bar.querySelector('.amba-mobile-search__input');
  const isHomepage = document.body.classList.contains('template-index');
  let isOpen = false;
  let closedSectionHeight = null;
let lockedSectionHeight = null;

  let isFixedUnderHeader = false;

function updateSearchBarPosition() {
  if (!isFixedUnderHeader || !isOpen) return;

  const headerRect = header.getBoundingClientRect();

  bar.style.setProperty(
    '--amba-mobile-search-top',
    `${Math.max(0, headerRect.bottom)}px`
  );
}

  function setOpen(next, focusInput) {
    if (!mobileQuery.matches && next) return;

const shouldOpen = Boolean(next) && mobileQuery.matches;
if (shouldOpen === isOpen) return;

const sectionHeightBeforeClose =
  !shouldOpen && headerSection
    ? Math.ceil(headerSection.getBoundingClientRect().height)
    : null;
    
if (shouldOpen && headerSection) {
  closedSectionHeight = headerSection.getBoundingClientRect().height;
}
    
isOpen = shouldOpen;

isFixedUnderHeader = isOpen && window.scrollY > 24;

bar.classList.toggle('is-open', isOpen);
bar.classList.toggle(
  'is-fixed-under-header',
  isFixedUnderHeader
);

header.classList.toggle(
  'amba-mobile-search-header-fixed',
  isFixedUnderHeader
);

if (isFixedUnderHeader) {
  updateSearchBarPosition();
} else {
  bar.style.removeProperty('--amba-mobile-search-top');
}

bar.setAttribute('aria-hidden', String(!isOpen));
    toggles.forEach((button) => button.setAttribute('aria-expanded', String(isOpen)));

    if (headerSection) {
      headerSection.classList.toggle('amba-mobile-search-open', isOpen);

if (isHomepage) {
  if (isOpen && isFixedUnderHeader) {
    headerSection.classList.add('amba-mobile-search-scrolled-open');

    headerSection.style.setProperty(
      '--amba-mobile-search-section-height',
      `${Math.ceil(
        closedSectionHeight ||
        headerSection.getBoundingClientRect().height
      )}px`
    );
  } else if (!isOpen && window.scrollY > 10) {
    // Keep the homepage section height stable when closing
    // the fixed search bar while the page is scrolled.
    headerSection.classList.add('amba-mobile-search-scrolled-open');

    headerSection.style.setProperty(
      '--amba-mobile-search-section-height',
      `${Math.ceil(
        closedSectionHeight ||
        headerSection.getBoundingClientRect().height
      )}px`
    );

    closedSectionHeight = null;
  } else {
    headerSection.classList.remove('amba-mobile-search-scrolled-open');
    headerSection.style.removeProperty('--amba-mobile-search-section-height');

    if (!isOpen) closedSectionHeight = null;
  }
}

else if (isOpen) {
  const baseHeight = Math.ceil(
    closedSectionHeight ||
    headerSection.getBoundingClientRect().height
  );

  if (isFixedUnderHeader) {
    headerSection.classList.add('amba-mobile-search-scrolled-open');

    headerSection.style.setProperty(
      '--amba-mobile-search-section-height',
      `${baseHeight}px`
    );
  } else {
    headerSection.classList.remove('amba-mobile-search-scrolled-open');

const rowHeight = Math.ceil(
  bar.getBoundingClientRect().height || 52
);

    headerSection.style.setProperty(
      '--amba-mobile-search-section-height',
      `${baseHeight + rowHeight}px`
    );
  }
} else if (window.scrollY > 10) {
  // Keep the exact section height when closing while scrolled.
  lockedSectionHeight =
    sectionHeightBeforeClose ||
    Math.ceil(headerSection.getBoundingClientRect().height);

  headerSection.classList.add('amba-mobile-search-scrolled-open');

  headerSection.style.setProperty(
    '--amba-mobile-search-section-height',
    `${lockedSectionHeight}px`
  );

  closedSectionHeight = null;
} else {
  headerSection.classList.remove('amba-mobile-search-scrolled-open');
  headerSection.style.removeProperty('--amba-mobile-search-section-height');

  lockedSectionHeight = null;
  closedSectionHeight = null;
}

}
  }
  
  toggles.forEach((button) => {
    button.addEventListener('click', (event) => {
      if (!mobileQuery.matches) return;
      event.preventDefault();
      event.stopPropagation();
      setOpen(!isOpen, !isOpen);
    });
  });

/*
 * Mobile all pages:
 * Dismiss the iOS keyboard when the user swipes the page
 * while typing, keeping the header and search bar available.
 */
  if (input) {
    let touchStartY = 0;
    let touchStartX = 0;

    document.addEventListener(
      'touchstart',
      (event) => {
        if (!mobileQuery.matches || !isOpen) return;

        const touch = event.touches[0];
        if (!touch) return;

        touchStartY = touch.clientY;
        touchStartX = touch.clientX;
      },
      { passive: true }
    );

    document.addEventListener(
      'touchmove',
      (event) => {
        if (!mobileQuery.matches || !isOpen) return;
        if (document.activeElement !== input) return;

        const touch = event.touches[0];
        if (!touch) return;

        const deltaY = touch.clientY - touchStartY;
        const deltaX = touch.clientX - touchStartX;

        // Ignore small movements and predominantly horizontal gestures.
        if (Math.abs(deltaY) < 10) return;
        if (Math.abs(deltaY) <= Math.abs(deltaX)) return;

        // Dismiss the iOS keyboard without closing the search bar.
        input.blur();
      },
      { passive: true }
    );
  }

window.addEventListener('scroll', () => {
  if (!isOpen) return;

  // Use separate thresholds to prevent rapid fixed/unfixed switching.
const shouldFix = window.scrollY > 1;

  if (shouldFix !== isFixedUnderHeader) {
    isFixedUnderHeader = shouldFix;

    bar.classList.toggle(
      'is-fixed-under-header',
      isFixedUnderHeader
    );

    header.classList.toggle(
      'amba-mobile-search-header-fixed',
      isFixedUnderHeader
    );

    if (headerSection) {
      if (isFixedUnderHeader) {
        // Switch to fixed search without changing page layout.
        const sectionHeight = Math.ceil(
          closedSectionHeight ||
          headerSection.getBoundingClientRect().height
        );

        headerSection.classList.add(
          'amba-mobile-search-scrolled-open'
        );

        headerSection.style.setProperty(
          '--amba-mobile-search-section-height',
          `${sectionHeight}px`
        );
      } else {
        // Restore the original expanded layout at the top.
        headerSection.classList.remove(
          'amba-mobile-search-scrolled-open'
        );

        const baseHeight = Math.ceil(
          closedSectionHeight ||
          headerSection.getBoundingClientRect().height
        );

        const rowHeight = Math.ceil(
          bar.getBoundingClientRect().height || 66
        );

        headerSection.style.setProperty(
          '--amba-mobile-search-section-height',
          `${baseHeight + rowHeight}px`
        );
      }
    }

    if (!isFixedUnderHeader) {
      bar.style.removeProperty('--amba-mobile-search-top');
    }
  }

  updateSearchBarPosition();
}, { passive: true });



  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', (event) => {
      if (!event.matches) setOpen(false, false);
    });
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && isOpen) setOpen(false, false);
  });

  document.addEventListener('click', (event) => {
    if (
      isOpen &&
      !bar.contains(event.target) &&
      !toggles.some((button) => button.contains(event.target))
    ) {
      setOpen(false, false);
    }
  });


})();